import {Inject, Injectable, InjectionToken} from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export const API_DATA_TOKEN = new InjectionToken<any>('API_DATA');

export const API_DATA: any = {
  'total_items': 223,
  'prefix': 'Avatar_',
  'suffix': '.jpg',
  'default_image': 'default'
};

@Injectable()
export class ImageClient {
  public _apiData: BehaviorSubject<any>;

  constructor(
    public http: HttpClient,
    @Inject(API_DATA_TOKEN) apiData: any) {
    this._apiData = new BehaviorSubject(apiData);
  }

  getConfig(): Observable<any> {
    return this._apiData.asObservable();
  }
}
